// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4366":"9b524a2e","6397":"a880a08c"}[chunkId] + ".chunk.css";
};